import userInitializersSaga from '~/sagas/initializers/user-initializers.saga';

export default userInitializersSaga;
